// import { safeJson } from '@/scripts/utils';
import dayjs from 'dayjs';
import { GroupCreateCard } from '@/pages/messages/components/groups/group-create-card';
import type { Chat } from '@/contexts/chat/scripts/hooks/useChats/types';
import { ChatCategory } from '@/contexts/chat/scripts/hooks/useChats/types';
import SysEncrypt from '../../sysEncrypt';
import SysDestroy from '../../sysDestroy';
import DividerTime from '../../dividerTime';
import classes from './index.module.scss';

const CreateMessage = ({ chat }: { chat?: Chat; payload?: string }) => {
  // const { member } = safeJson(payload ?? '{}', {});
  const isGroup = useMemo(
    () => chat?.category === ChatCategory.GROUP,
    [chat?.category]
  );

  return (
    <div className={classes.create_messages}>
      <DividerTime>{dayjs(chat?.create_at).format('MMM D, YYYY HH:mm')}</DividerTime>
      <SysEncrypt />
      <SysDestroy />
      {isGroup && <GroupCreateCard chat={chat as Chat} />}
    </div>
  );
};

export default memo(CreateMessage);
